interface SuggestionChipsProps {
  suggestions: string[];
  onSelect: (label: string) => void;
}

const SuggestionChips = ({ suggestions, onSelect }: SuggestionChipsProps) => {
  if (!suggestions.length) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-0.5">
      {suggestions.map((label) => (
        <button
          key={label}
          type="button"
          onClick={() => onSelect(label)}
          className="px-3.5 py-2 border border-gray-200 rounded-full text-[13px] text-gray-700 bg-white hover:border-gray-300 hover:text-gray-900 transition-colors cursor-pointer"
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default SuggestionChips;
